function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 67.2748073,
  height: 41,
  rx: 1.6
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "objectBoundingBox",
  x: 0,
  y: 0,
  width: 67.2748073,
  height: 41,
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("rect", {
  id: "path-3",
  x: 0,
  y: 0,
  width: 46,
  height: 41,
  rx: 1.6
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "objectBoundingBox",
  x: 0,
  y: 0,
  width: 46,
  height: 41,
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: 2020,
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Usuario-n\\xE3o-autenticado",
  transform: "translate(-27.000000, -371.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "illustration-empty",
  transform: "translate(27.000000, 371.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#E3E9F0",
  opacity: 0.6,
  x: 9.09494702e-13,
  y: 38,
  width: 80,
  height: 3,
  rx: 1.5
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(6.872131, 0.000000)",
  stroke: "#B3BECD"
}, /*#__PURE__*/React.createElement("use", {
  id: "Rectangle",
  mask: "url(#mask-2)",
  strokeWidth: 2,
  fill: "#F5F8FA",
  strokeDasharray: "2,1",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("use", {
  id: "Rectangle-Copy-2",
  mask: "url(#mask-4)",
  strokeWidth: 2,
  fill: "#FFFFFF",
  strokeDasharray: "2,1",
  xlinkHref: "#path-3"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(20.026775, 17.353130)",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 5.65685425,
  x2: 5.65685425,
  y2: -3.14018492e-16,
  id: "Path-2"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 5.65685425,
  x2: 5.65685425,
  y2: 0,
  id: "Path-2-Copy",
  transform: "translate(2.828427, 2.828427) scale(-1, 1) translate(-2.828427, -2.828427) "
}))))));

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "41px",
    viewBox: "0 0 80 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.4b93d2a8.svg";
export { ForwardRef as ReactComponent };